import {CardGroup} from 'semantic-ui-react';
import UltyLoadingPlaceholderCard from './UltyLoadingPlaceholderCard';
import PropTypes from 'prop-types';


const UltyLoadingPlaceholderCardGroup = ({itemsPerRow = 4, cardQuantity = 8, ...props}) => {
    return (
        <CardGroup
          itemsPerRow={itemsPerRow}
          className={props.className}
        >
            {[...Array(cardQuantity).keys()].map((i) => (
                <UltyLoadingPlaceholderCard key={i} />
            ))}
        </CardGroup>
    );
};

UltyLoadingPlaceholderCardGroup.propTypes = {
    itemsPerRow: PropTypes.number,
    cardQuantity: PropTypes.number,
};

export default UltyLoadingPlaceholderCardGroup;
